import api from "./axios";

export const createSalesOrder = (formData) =>
    api.post("/sales-orders/create", formData, {
        headers: { "Content-Type": "application/json" },
    });

export const getAllSalesOrders = () => api.get("/sales-orders/all");

export const getSalesOrderById = (id) => api.get(`/sales-orders/${id}`);

export const searchSalesOrder = (query) => api.get(`/sales-orders/search?searchKey=${query}`);

export const getPaginatedSalesOrders = (page, size, config = {}) =>
    api.get(`/sales-orders?page=${page}&size=${size}`, config);

export const softDeleteSalesOrder = (salesOrderID, userId) =>
    api.delete(`/sales-orders/softDelete?salesOrderID=${salesOrderID}&userId=${userId}`);

export const updateSalesOrder = (salesOrderID, userID, body) =>
    api.put(`/sales-orders/update?salesOrderID=${salesOrderID}&userID=${userID}`, body, {
        headers: { "Content-Type": "application/json" }
    });

export const approveSalesOrder = (salesOrderStatus, userId, salesOrderId) =>
    api.post(`/sales-orders/Approval?userId=${userId}&salesOrderStatus=${salesOrderStatus}&salesOrderId=${salesOrderId}`);

export const getPendingOrderCount = () => api.get("/sales-orders/getPendingOrderCount");

export const updateSalesOrderDeliveryStatus = (orderId) =>
    api.get(`/sales-orders/updateDelivery/${orderId}`);

export const submitSalesOrderPayment = (paymentData) =>
    api.post("/sales-orders/payment", paymentData, {
        headers: { "Content-Type": "application/json" },
    });

export const updateChequeStatus = (paymentId, status, userId) =>
    api.post(`/sales-orders/update-cheque-status?paymentId=${paymentId}&status=${status}&userId=${userId}`);

export const getPendingCheques = (salesOrderId) =>
    api.get(`/sales-orders/pending-cheques/${salesOrderId}`);

